import { throttle } from 'lodash';
import { useRef, useEffect } from 'react';

const THROTTLE_DELAY = 150;

interface InfiniteLoadObserverProps {
  onIntersect?: () => void;
  thresholdAbove?: number;
}

const InfiniteLoadObserver = ({
  onIntersect,
  thresholdAbove = 0,
}: InfiniteLoadObserverProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && onIntersect) {
      const onScroll = throttle(() => {
        if (ref.current) {
          const { top } = ref.current.getBoundingClientRect();

          if (top - thresholdAbove <= window.innerHeight) {
            onIntersect();
          }
        }
      }, THROTTLE_DELAY);

      window.addEventListener('scroll', onScroll);

      return () => {
        window.removeEventListener('scroll', onScroll);
      };
    }
  }, [onIntersect, thresholdAbove]);

  return onIntersect ? <div ref={ref} style={{ height: '1px' }} /> : null;
};

export default InfiniteLoadObserver;
